export const tableView = {
  name: "table-view" as const,
  svg: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path fill-rule="evenodd" d="M3.1 4a.9.9 0 0 1 .9-.9h16a.9.9 0 0 1 .9.9v16a.9.9 0 0 1-.9.9H4a.9.9 0 0 1-.9-.9V4Zm1.8.9v4.2h6.2V6.5a.9.9 0 1 1 1.8 0v2.6h6.2V4.9H4.9Zm14.2 6h-6.2v3.2h6.2v-3.2Zm0 5h-6.2v3.2h6.2v-3.2Zm-8 3.2v-3.2H4.9v3.2h6.2Zm-6.2-5h6.2v-3.2H4.9v3.2Z" clip-rule="evenodd"/></svg>`,
  keywords: ["table-view"],
  category: "utility" as const,
};
